export default __webpack_public_path__ + "static/media/Animations_Bar14.4b46c30b.svg";